import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Swal from "sweetalert2";

const CrearBoletin = () => {
  const { userData } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ titulo: "", descripcion: "", fechaPublicacion: "" });
  const [archivo, setArchivo] = useState(null);
  const API = process.env.REACT_APP_API_URL;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  const maxSize = 10 * 1024 * 1024; // 10 MB

  if (file && file.size > maxSize) {
    Swal.fire("❌ Archivo demasiado grande", "El archivo debe ser menor a 10 MB.", "error");
    setArchivo(null);
    e.target.value = null; // limpia el input
    return;
  }

  setArchivo(file);
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Creando boletín...",
      text: "Por favor espera mientras se guarda el boletín.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const formData = new FormData();
      formData.append("titulo", form.titulo);
      formData.append("descripcion", form.descripcion);
      formData.append("fechaPublicacion", form.fechaPublicacion);
      formData.append("subidoPor", userData?.Id);
      formData.append("archivoPdf", archivo);

      const res = await fetch(`${API}/api/boletines/crear`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) throw new Error("No se pudo crear el boletín. Intenta nuevamente.");

      Swal.close();
      Swal.fire("✅ Boletín creado", "El boletín fue guardado correctamente.", "success");
      navigate(-1);
    } catch (error) {
      Swal.close();
      Swal.fire("❌ Error", error.message, "error");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-xl mx-auto p-6 bg-white shadow rounded">
      <h2 className="text-xl font-bold mb-4">Crear nuevo boletín</h2>
      <input
        name="titulo"
        placeholder="Título"
        value={form.titulo}
        onChange={handleChange}
        required
        className="w-full p-2 border mb-2 rounded"
      />
      <input
        name="descripcion"
        placeholder="Descripción"
        value={form.descripcion}
        onChange={handleChange}
        required
        className="w-full p-2 border mb-2 rounded"
      />
      <input
        type="date"
        name="fechaPublicacion"
        value={form.fechaPublicacion}
        onChange={handleChange}
        required
        className="w-full p-2 border mb-2 rounded"
      />
      <input
        type="file"
        accept="application/pdf"
        onChange={handleFileChange}
        required
        className="w-full mb-4"
      />
      <p className="text-sm text-gray-500 mb-2">Solo archivos PDF menores a 10MB.</p>
      <button
        type="submit"
        className="bg-green-700 text-white px-4 py-2 rounded hover:bg-green-800"
      >
        Guardar
      </button>
    </form>
  );
};

export default CrearBoletin;
